import type {
	BothFullMissionStates,
	SpecialEffect,
} from '@mission.io/mission-toolkit'

type State = ?BothFullMissionStates

export function getTrimTimeOfCurrentSong(state: State): ?number {
	return state?.launchpad.song?.trimStartTime
}

export function getCurrentSongUrl(state: State): ?string {
	return state?.launchpad.song?.url
}

export function getSpecialEffects(state: State): ?{ [string]: SpecialEffect } {
	return state?.launchpad.specialEffects
}

export function getSpecialEffect(
	state: State,
	specialEffectId: ?string
): ?SpecialEffect {
	return specialEffectId ? getSpecialEffects(state)?.[specialEffectId] : null
}

export function getCurrentAmbianceId(state: State): ?string {
	return state?.launchpad.ambiance?.id
}
